const LibraryTypeEnum = {
    TEXTURES: "textures",
    HATS: "hats",
    SOUNDS: "sounds"
};

export default LibraryTypeEnum;